let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hWVD3")).then(() => parcelRequire('e1Pao'));